import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import {  MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/base/base.component';
import { ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { NamedColor } from 'src/app/domainObjects/namedColor';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { KeyboardService } from 'src/app/services/keyboard/keyboard.service';

class ViewModel {
  colors: NamedColor[];
  textItems: ColoredTextItem[] = [];
  currentColor: NamedColor;
  currentName: string;
  sourceItems: ColoredTextItem[] = [];

  constructor(items: ColoredTextItem[],sourceItems: ColoredTextItem[]) {
    const itemsCopy = items.map(r => new ColoredTextItem(r.text, r.color)) ?? [];
    this.textItems = itemsCopy ?? [];
    this.colors = NamedColorList;
    this.currentColor = this.colors[0];
    const sourceItemsCopy = sourceItems.map(r => new ColoredTextItem(r.text, r.color)) ?? [];
    this.sourceItems = sourceItemsCopy ?? [];
  }
}

@Component({
    selector: 'app-text-entry-field',
    templateUrl: './text-entry-field.component.html',
    styleUrls: ['./text-entry-field.component.css'],
    standalone: false
})
export class TextEntryFieldComponent extends BaseComponent implements OnInit{
  title: string;
  isShowHeader: boolean = true;

  viewModel: ViewModel;
   @ViewChild('dialogRoot', { static: true }) dialogRoot!: ElementRef;
  constructor(
    private dialogRef: MatDialogRef<TextEntryFieldComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData,
    errorLogger: ErrorReportingService,
     private keyboardService: KeyboardService,
    matDialog: MatDialog) {
      super(errorLogger, matDialog);
  }

    @HostListener('document:keydown.escape')
      onEscapePress() {
        this.cancel();
    }
    ngOnInit(): void {
      this.title = this.dialogData.title;
      this.isShowHeader = this.dialogData.isShowHeader;

      this.viewModel = new ViewModel(this.dialogData.items,this.dialogData.sourceItems);
    }
  
    save(): void {
      var isvalid=true;
      this.viewModel.textItems.forEach(item=>{
        if(item.text==null || item.text==""){
          isvalid=false;
          return;
        }
      })
      if(!isvalid){
        this.displayWarning("No entries can be empty, please enter value.","Warning.");
        return;
      }

      this.dialogRef.close({items: this.viewModel.textItems,eventname:'save'});
    }
  
    cancel(): void {
      this.dialogRef.close({items: this.viewModel.textItems,eventname:'cancel'});
    }
}
